<div class="action-bar">
  <ng-content select="ng-container[action-bar-items]" />
</div>
<ng-content />
